import React, { FC, useEffect, useState } from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { Select } from 'antd';
import { Selector } from '../../types';
import { selectorsOrder } from '../../utils';

const SelectorSelect: FC<
  {
    onChange?: (value: Selector) => void;
    exclude?: string[];
    value?: string | Selector;
    minSelector?: Selector;
    maxSelector?: Selector;
    descending?: boolean;
    disabled?: boolean;
  } & WithTranslation
> = ({ t, onChange, exclude, value, minSelector = Selector.Drillhole, maxSelector = Selector.Partners, descending = false, disabled = false }) => {
  const [currentValue, setValue] = useState(value);

  useEffect(() => {
    let nextValue = value || currentValue;
    if (nextValue && (exclude || []).includes(nextValue)) nextValue = undefined;
    setValue(nextValue);
  }, [exclude, value]); // eslint-disable-line react-hooks/exhaustive-deps

  const onSelect = (value: any) => {
    setValue(value);
    onChange && onChange(value);
  };

  const start = selectorsOrder.findIndex((x) => x === minSelector);
  const end = selectorsOrder.findIndex((x) => x === maxSelector);
  let options = selectorsOrder.slice(start, end + 1);
  if (descending) options = options.reverse();
  return (
    <Select
      disabled={disabled}
      placeholder={t('SelectSelector')}
      onChange={onSelect}
      style={{ width: '100%', height: '100%' }}
      showSearch
      value={currentValue}
      filterOption
    >
      {options.map((s) => (
        <Select.Option key={s} value={s}>
          {t(s)}
        </Select.Option>
      ))}
    </Select>
  );
};

export default withTranslation()(SelectorSelect);
